const prefixStringWithIndexPlusOne = (string, index) => `${index !== undefined ? `${index + 1}. ` : ''}${string}`;

const getIsString = (value) => typeof value === 'string' || value instanceof String;

// input:
// i am a string friend!
// output:
// I Am A String Friend!
// https://stackoverflow.com/questions/32589197/how-to-capitalize-the-first-letter-of-each-word-in-a-string-using-javascript/45620677#45620677
const capitaliseTheStartOfEachWord = (string) => string.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase());


export {
  prefixStringWithIndexPlusOne,
  getIsString,
  capitaliseTheStartOfEachWord,
};


